import { useMemo } from 'react';

import { StoreItemWithOptionalInventorySummary } from '@givebacks/api/store';
import { FormProvider } from '@givebacks/formy/components';
import { centsToDollar } from 'core/Utils';
import { Stack, Title } from 'ui';

import { MembershipItemForm } from './MembershipForm';
import { StoreItemForm } from './StoreItemForm';

const StoreItemOrderForm = ({
  storeItem,
  storeId,
}: {
  storeItem: StoreItemWithOptionalInventorySummary;
  storeId?: string;
}) => {
  const additionalFields = useMemo(() => storeItem.options ?? [], [storeItem.options]);

  const isMembershipItem = storeItem.type === 'StoreItems::Membership';

  if (!storeItem || !storeId) return null;

  return (
    <FormProvider>
      <Stack gap="lg" pt="xl">
        <Stack gap="xs">
          <Title order={2}>{storeItem.name}</Title>
          <Title order={4} c="mint.7">
            {storeItem.variable_price ? 'Select Your Price' : centsToDollar(storeItem.price)}
          </Title>
        </Stack>
        {isMembershipItem ? (
          <MembershipItemForm
            options={additionalFields}
            units={storeItem.units}
            allowedYears={storeItem.allowed_years}
            storeId={storeId}
            storeItem={storeItem}
          />
        ) : (
          <StoreItemForm storeId={storeId} storeItem={storeItem} />
        )}
      </Stack>
    </FormProvider>
  );
};

export { StoreItemOrderForm };
